import { render, staticRenderFns } from "./after_login.vue?vue&type=template&id=ff33ee52&scoped=true&"
import script from "./after_login.vue?vue&type=script&lang=js&"
export * from "./after_login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff33ee52",
  null
  
)

export default component.exports